import type { GenericTranslationsObject } from '@payloadcms/translations'

export const my: GenericTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-seo': {
    almostThere: 'နည်းနည်းပဲကျန်သေးသည်',
    autoGenerate: 'အလိုအလျောက်ထုတ်လုပ်မည်',
    bestPractices: 'အကောင်းဆုံးအကဲဖြတ်မှုများ',
    characterCount: '{{current}}/{{minLength}}-{{maxLength}} လုံး, ',
    charactersLeftOver: '{{characters}} လုံးကျော်နေသည်',
    charactersToGo: '{{characters}} လုံးလိုသေးသည်',
    charactersTooMany: '{{characters}} လုံးများသွားသည်',
    checksPassing: '{{current}}/{{max}} စစ်ဆေးမှုအောင်မြင်ခဲ့သည်',
    good: 'ကောင်းမွန်သည်',
    imageAutoGenerationTip: 'အလိုအလျောက်ထုတ်လုပ်မှုသည် ရွေးချယ်ထားသော ဟီးရိုးပုံကိုယူမည်။',
    lengthTipDescription:
      'ဤအကြောင်းအရာသည် {{minLength}} နှင့် {{maxLength}} အကြားရှိသင့်သည်။ အရည်အသွေးမြင့် meta ဖော်ပြချက်ရေးသားရန်အတွက်အကြံဉာဏ်များကို ကြည့်ရန် ',
    lengthTipTitle:
      'ဤအကြောင်းအရာသည် {{minLength}} နှင့် {{maxLength}} အကြားရှိသင့်သည်။ အရည်အသွေးမြင့် meta ခေါင်းစဉ်ရေးသားရန်အတွက်အကြံဉာဏ်များကို ကြည့်ရန် ',
    missing: 'ပျောက်နေသည်',
    noImage: 'ပုံမရှိပါ',
    preview: 'မကြိုတင်ကြည့်ရှုနိုင်ပါ',
    previewDescription:
      'တိကျသော ရှာဖွေမှုရလဒ်များသည် အကြောင်းအရာနှင့် ရှာဖွေရေးအသင့်တော်မှုပေါ်မူတည်၍ မတူကွဲပြားနိုင်သည်။',
    tooLong: 'တော်တော်ကြာသည်',
    tooShort: 'တော်တော်တိုသည်',
  },
}
